import axios from "@/http";
import { handleGetRequestParams } from '@/common/js/util'

class AbnormalOrder {
  /* 异常订单列表 */
  static getAbnormalOrderList(options) {
    let url = `/oa/api/exception/order/list?`;
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 录入 */
  static postAbnormalOrderEntry(data) {
    let url = `/oa/api/exception/order/save`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 详情 */
  static postAbnormalOrderDetails(id) {
    let url = `/oa/api/exception/order/detail?id=${id}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 作废 */
  static postNullify(data) {
    let url = `/oa/api/exception/order/invalid`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
}

export default AbnormalOrder;